import { BaseHttpResponseError } from './base-http.error';

export class UserNotFoundError extends BaseHttpResponseError {}
